module.exports = __webpack_public_path__ + "static/img/8.68867b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/1/zh/8.png
// module id = ls9m
// module chunks = 0